// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type AggregatedNotificationSettings = {
    id?: null | string;
    topic?: Topic;
    channel?: Array<Channel>;
    fleets?: Array<string>;
    email?: string;
};

export type App = {
    name?: string;
    title?: string;
    imageRelativePath?: null | string;
    imagePath?: null | string;
    description?: null | string;
    architecture?: null | string;
    latestVersion?: string;
    modules?: Array<string>;
    externalUrl?: null | string;
    userConsentRequired?: boolean;
    vulnerabilityMetric?: null | VulnerabilityMetric;
    appliedTo?: Array<AppAppliedTo>;
    legalNotices?: Array<VersionUrl>;
    readme?: Array<VersionUrl>;
    changelog?: Array<VersionUrl>;
    hint?: null | string;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export type AppAppliedTo = {
    fleetId?: string;
    version?: string;
    successCount?: number | string;
    appliedCount?: number | string;
    name?: null | string;
    deviceCount?: null | number | string;
    imageRelativePath?: null | string;
};

export type AppConsentRequest = {
    fleetId: string;
    appName: string;
    version: string;
};

export type ApplicationDetailResponse = {
    app: App;
};

export type ApplyFirmwareConsentRequest = {
    version: string;
};

export type AttributeKeyValue = {
    key?: string;
    value?: string;
};

export type AttributeMappingInput = {
    key?: null | string;
    value?: null | string;
};

export const AvailableLanguages = { DE: 'de', EN: 'en' } as const;

export type AvailableLanguages = typeof AvailableLanguages[keyof typeof AvailableLanguages];

export type BulkDeleteResponse = {
    deleted: number | string;
    errors?: null | Array<string>;
};

export type CancelUpdateRequest = {
    updateId: UpdateIdDto;
    tag: string;
};

export type Capabilities = {
    mobile3g?: boolean;
    bluetooth?: boolean;
    wifi?: boolean;
    tpm2?: boolean;
};

export const CapabilityValue = {
    YES: 'yes',
    NO: 'no',
    OPTIONAL: 'optional'
} as const;

export type CapabilityValue = typeof CapabilityValue[keyof typeof CapabilityValue];

export type CapabilityValues = {
    mobile_3g?: CapabilityValue;
    bluetooth?: CapabilityValue;
    wifi?: CapabilityValue;
    tpm2?: CapabilityValue;
};

export type CertInfo = {
    est?: boolean;
    expires?: string;
};

export const Channel = { EMAIL: 'Email', BELL: 'Bell' } as const;

export type Channel = typeof Channel[keyof typeof Channel];

export type CompatibilityPropertiesResponse = {
    compatibilityId?: null | string;
    manufacturer?: string;
    model?: string;
};

export const ConnectionState = { CONNECTED: 'Connected', DISCONNECTED: 'Disconnected' } as const;

export type ConnectionState = typeof ConnectionState[keyof typeof ConnectionState];

export type CpuUsageMetric = {
    utilization?: number | string;
};

export type CreateUserRequest = {
    email?: null | string;
    emailVerified?: boolean;
    enabled?: boolean;
    firstName?: null | string;
    lastName?: null | string;
    requiredActions?: null | Array<string>;
    groups?: null | Array<string>;
    roleMapping?: null | Array<RoleMappingInput>;
    attributeMapping?: null | Array<AttributeMappingInput>;
    attributes?: null | {
        [key: string]: Array<string>;
    };
};

export type DeleteDevicesRequest = {
    deviceIds: Array<string>;
    fleetId: string;
};

export type DeleteFleetsRequest = {
    fleetIds: Array<string>;
};

export type DeleteUsersRequestBody = {
    ids?: null | Array<string>;
    userIds?: null | Array<string>;
};

export type Device = {
    deviceId?: string;
    moduleId?: null | string;
    deviceClassId?: null | string;
    deviceFleetId?: null | string;
    lastAttemptedUpdateId?: null | UpdateInfo;
    installationStatus?: null | DeviceInstallationState;
    installedUpdateId?: null | UpdateInfo;
    installedFirmware?: null | FirmwareInfo;
    onLatestUpdate?: null | boolean;
    lastInstallationId?: null | string;
    lastInstallResult?: null | FirmwareInstallResultProps;
    connectionState?: null | ConnectionState;
    syncStatus?: null | SyncStatus;
    generalConsent?: null | boolean;
    factoryResetStatus?: null | string;
    factoryResetStatusDate?: null | string;
    factoryResetResult?: null | FactoryResetResult;
    factoryResetCommandIssuedAt?: null | string;
    factoryResetLastPublishedEventAt?: null | string;
    isRebooting?: null | boolean;
    updateVersionConsentRequired?: null | string;
    lastUpdateVersionConsentApplied?: null | string;
    arch?: null | string;
    hardwareModel?: null | string;
    deviceNetworks?: Array<DeviceNetwork>;
    provisioningConfig?: null | ProvisioningConfig;
    availableProperties?: null | DeviceAvailableProperties;
    installedApps?: Array<InstalledApps>;
    bootTime?: null | string;
    factoryResetOptions?: Array<string>;
    sshPubKey?: null | string;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export type DeviceApplicationModuleResponse = {
    name?: string;
    status?: DeviceApplicationState;
};

export type DeviceApplicationResponse = {
    name?: string;
    version?: DeviceApplicationVersionResponse;
    isSystemApp?: boolean;
};

export const DeviceApplicationState = {
    SUCCEEDED: 'Succeeded',
    FAILED: 'Failed',
    BACK_OFF: 'BackOff',
    PENDING: 'Pending',
    RUNNING: 'Running',
    STOPPED: 'Stopped',
    APPLIED: 'Applied',
    NONE: 'None',
    UNKNOWN: 'Unknown'
} as const;

export type DeviceApplicationState = typeof DeviceApplicationState[keyof typeof DeviceApplicationState];

export type DeviceApplicationVersionResponse = {
    applicationId?: string;
    deviceFleetId?: string;
    imageRelativePath?: string;
    imagePath?: null | string;
    title?: string;
    description?: null | string;
    version?: string;
    externalUrl?: null | string;
    active?: boolean;
    status?: DeviceApplicationState;
    lastUpdated?: string;
    failedModules?: Array<string>;
    modules?: Array<DeviceApplicationModuleResponse>;
    userConsentRequired?: boolean;
    installedVersion?: null | string;
    updateVersion?: null | string;
    legalNotice?: null | string;
    readme?: null | string;
    changelog?: null | string;
};

export type DeviceAvailableProperties = {
    ssh?: null | DeviceAvailableProperty;
    factoryReset?: null | DeviceAvailableProperty;
    networkStatus?: null | DeviceAvailableProperty;
    deviceUpdateConsent?: null | DeviceAvailableProperty;
    reboot?: null | DeviceAvailableProperty;
    wifiCommissioning?: null | WifiCommissioningProperty;
};

export type DeviceAvailableProperty = {
    version?: number | string;
};

export type DeviceDeleteErrorDetail = {
    deviceId: string;
    error: unknown;
};

export type DeviceDeleteResponse = {
    deleted: number | string;
    errors: Array<DeviceDeleteErrorDetail>;
};

export type DeviceHardwareModel = {
    model?: string;
    displayName?: string;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export const DeviceInstallationState = {
    SUCCEEDED: 'Succeeded',
    IN_PROGRESS: 'InProgress',
    FAILED: 'Failed',
    CANCELED: 'Canceled',
    INCOMPATIBLE: 'Incompatible'
} as const;

export type DeviceInstallationState = typeof DeviceInstallationState[keyof typeof DeviceInstallationState];

export type DeviceMethodResult = {
    status?: number | string;
    payload?: unknown;
};

export type DeviceMetricResponse = {
    cpuUsage?: null | CpuUsageMetric;
    memoryUsage?: null | MemoryUsageMetric;
    fileSystemUsage?: null | FileSystemUsageMetric;
    temperature?: null | TemperatureMetric;
};

export type DeviceNetwork = {
    addrV4?: null | string;
    addrV6?: null | string;
    ipv4?: null | InternetProtocol;
    ipv6?: null | InternetProtocol;
    mac?: string;
    name?: string;
    online?: null | boolean;
};

export type DevicesResponse = {
    devices?: Array<Device>;
    totalCount?: bigint | string;
};

export type EnrichedGroup = {
    id?: null | string;
    name?: null | string;
    path?: null | string;
};

export type EnrichedUser = {
    id?: null | string;
    username?: null | string;
    email?: null | string;
    firstName?: null | string;
    lastName?: null | string;
    enabled?: boolean;
    emailVerified?: boolean;
    createdTimestamp?: null | bigint | string;
    requiredActions?: Array<string>;
    attributes?: Array<AttributeKeyValue>;
    roles?: Array<KeycloakRole>;
    groups?: Array<EnrichedGroup>;
    fleetMetaData?: Array<FleetMetaDataDto>;
};

export type Event = {
    type?: string;
    timestamp?: string;
    deviceId?: null | string;
    fleetId?: null | string;
    severity?: string;
    topic?: null | string;
    payload?: EventPayload;
    errorCode?: null | number | string;
    fleetDisplayName?: null | string;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export type EventDto = {
    id?: string;
    type?: string;
    timestamp?: string;
    deviceId?: null | string;
    fleetId?: null | string;
    severity?: string;
    payload?: null | EventPayloadDto;
    errorCode?: null | number | string;
};

export type EventGridConfigInfo = {
    topicEndpoint: null | string;
    topicName: null | string;
    hasAccessKey: boolean;
};

export type EventListResponse = {
    events?: Array<Event>;
    totalCount?: bigint | string;
    eventTypes?: null | Array<string>;
};

export type EventPayload = {
    severity?: null | string;
    deviceFleetId?: null | string;
    timestamp?: null | string;
    tenant?: null | string;
    traceId?: null | string;
    traceContext?: null | TraceContext;
    deviceId?: null | string;
    downloadLink?: null | string;
    sha256?: null | string;
    stateId?: null | string;
    hardwareModel?: null | string;
    capabilities?: null | Capabilities;
    topic?: null | string;
    applicationId?: null | string;
    applicationTitle?: null | string;
    applicationModules?: Array<string>;
    module?: null | string;
    name?: null | string;
    version?: null | string;
    est?: null | boolean;
    expiryDate?: null | string;
    expireDays?: null | number | string;
    updateId?: null | UpdateId;
    provider?: null | string;
    movedTo?: null | string;
    errorMsg?: null | string;
    rebootReason?: null | string;
    bootId?: null | string;
};

export type EventPayloadDto = {
    applicationId?: null | string;
    applicationTitle?: null | string;
    deviceHardwareModel?: null | string;
    downloadLink?: null | string;
    sha256?: null | string;
    module?: null | string;
    capabilities?: null | Capabilities;
};

export type ExistingUserIdResponse = {
    id: string;
};

export type FactoryResetRequest = {
    restore: null | Array<string>;
};

export type FactoryResetResult = {
    error?: string;
    path?: Array<string>;
    context?: null | string;
    status?: FactoryResetStatus;
};

export const FactoryResetStatus = {
    MODE_SUPPORTED: 'ModeSupported',
    MODE_UNSUPPORTED: 'ModeUnsupported',
    BACKUP_RESTORE_ERROR: 'BackupRestoreError',
    CONFIGURATION_ERROR: 'ConfigurationError',
    UNKNOWN: 'Unknown'
} as const;

export type FactoryResetStatus = typeof FactoryResetStatus[keyof typeof FactoryResetStatus];

export type FileSystemUsageMetric = {
    utilization?: number | string;
    total?: number | string;
    available?: number | string;
};

export type FirmwareContainer = {
    containerName?: string;
    displayName?: string;
    hardwareModel?: string;
    latestFirmwareVersion?: null | string;
    availableFirmware?: Array<FirmwareMetaData>;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export type FirmwareInfo = {
    manufacturer?: string;
    osName?: string;
    version?: string;
};

export type FirmwareInstallResultProps = {
    resultCode?: null | number | string;
    extendedResultCode?: null | number | string;
    resultDetails?: null | string;
    timeStamp?: null | string;
};

export type FirmwareMetaData = {
    version?: string;
    imageFileName?: string;
    yocto?: null | string;
    createdAt?: null | string;
    legalNoticeLink?: null | string;
    imageFileLinks?: null | string;
    swuFileLinks?: null | string;
    capabilities?: null | CapabilityValues;
};

export type Fleet = {
    creator?: string;
    description?: null | string;
    name?: string;
    deviceCount?: number | string;
    imageRelativePath?: null | string;
    supportedDeviceHardwareModels?: Array<string>;
    baseDeploymentDisabled?: boolean;
    generalConsent?: boolean;
    resetConsentOnFail?: boolean;
    localWebservice?: boolean;
    disconnectedDeviceCount?: number | string;
    updatingDeviceCount?: number | string;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export type FleetCreatedResponse = {
    fleetId: string;
    thumbnailUrl: null | string;
};

export type FleetDetailResponse = {
    fleet: Fleet;
    devices: Array<Device>;
    users?: null | Array<string>;
};

export type FleetMetaDataDto = {
    fleetId?: null | string;
    displayName?: null | string;
};

export const FleetsView = { GRID: 'Grid', TABLE: 'Table' } as const;

export type FleetsView = typeof FleetsView[keyof typeof FleetsView];

export type FleetUpdatedResponse = {
    thumbnailUploadUrl: null | string;
};

export type GenerateOsImageCapabilitiesRequest = {
    bluetooth: boolean;
    mobile_3g: boolean;
    tpm2: boolean;
    wifi: boolean;
};

export type GenerateOsImageRequest = {
    deviceId: string;
    deviceFleetId: string;
    firmwareContainerId: string;
    firmwareVersion: string;
    capabilities?: null | GenerateOsImageCapabilitiesRequest;
    endorsementKey?: null | string;
};

export type HealthResponse = {
    status: string;
    timestamp: string;
    version: string;
};

export type IFormFile = Blob | File;

export type ImportFirmwareRequest = {
    hardwareModel: string;
    containerName: string;
    firmwareVersion: string;
    tenant: string;
};

export type InstallAppRequest = {
    appName: string;
    fleetIds: Array<string>;
    appTitle?: null | string;
};

export type InstalledAppModules = {
    name?: string;
    status?: DeviceApplicationState;
};

export type InstalledApps = {
    name?: string;
    status?: DeviceApplicationState;
    version?: string;
    lastUpdated?: string;
    modules?: Array<InstalledAppModules>;
    isSystemApp?: boolean;
};

export type InstallUpdateRequest = {
    updateId: UpdateIdDto;
    tag: string;
};

export type InternetProtocol = {
    addrs?: Array<IpAddress>;
    dns?: Array<string>;
    gateways?: Array<string>;
};

export type IoTHubConfigInfo = {
    hostName: null | string;
    hasConnectionString: boolean;
};

export type IpAddress = {
    addr?: string;
    dhcp?: null | boolean;
    prefixLen?: null | number | string;
};

export type KeycloakGroup = {
    id: null | string;
    name: null | string;
    path: null | string;
    members: null | Array<KeycloakUser>;
    roles?: null | Array<KeycloakRole>;
};

export type KeycloakRequiredAction = {
    alias: null | string;
    name: null | string;
    providerId: null | string;
    enabled: boolean;
    defaultAction: boolean;
    priority: number | string;
};

export type KeycloakRole = {
    id: null | string;
    name: null | string;
    description: null | string;
    composite: null | boolean;
    clientRole: null | boolean;
    inherit: null | boolean;
    containerId?: null | string;
};

export type KeycloakUser = {
    id: null | string;
    username: null | string;
    email: null | string;
    firstName: null | string;
    lastName: null | string;
    enabled: boolean;
    emailVerified: boolean;
    createdTimestamp: null | bigint | string;
    attributes: null | {
        [key: string]: Array<string>;
    };
    requiredActions: null | Array<string>;
};

export type MemoryUsageMetric = {
    utilization?: number | string;
    total?: number | string;
    available?: number | string;
};

export type MessageResponse = {
    message: string;
};

export type MongoDbConfigInfo = {
    databaseName: null | string;
    hasConnectionString: boolean;
};

export type MoveDevicesRequest = {
    deviceIds: Array<string>;
    toFleetId: string;
    fromFleetId?: null | string;
};

export type Notification = {
    fleetId?: string;
    fleet?: null | string;
    deviceId?: null | string;
    event?: string;
    timestamp?: string;
    eventId?: null | string;
    downloadLink?: null | string;
    applicationId?: null | string;
    applicationTitle?: null | string;
    module?: null | string;
    releaseHardwareModel?: null | string;
    releaseVersion?: null | string;
    expiryDate?: null | string;
    expiryDays?: null | number | string;
    est?: null | boolean;
    traceId?: null | string;
    id?: null | string;
    read?: boolean;
};

export type NotificationSettingItemDto = {
    topic: string;
    channel: Array<Channel>;
    fleets: Array<string>;
};

export type NotificationsResponse = {
    items?: Array<Notification>;
    pagination?: PaginationMeta;
    unreadCount?: number | string;
};

export const Order = { ASC: 'asc', DESC: 'desc' } as const;

export type Order = typeof Order[keyof typeof Order];

export type OsGenReportFailedRequest = {
    deviceId: string;
    error: string;
    tenant: string;
    traceContext: null | string;
};

export type OsGenReportSuccessRequest = {
    file: string;
    deviceId: string;
    tenant: string;
    traceContext: null | string;
};

export type PaginatedResponseOfFleet = {
    items?: Array<Fleet>;
    pagination?: PaginationMeta;
};

export type PaginationMeta = {
    currentPage?: number | string;
    itemsPerPage?: number | string;
    totalItems?: bigint | string;
    totalPages?: number | string;
};

export type PinnedDevice = {
    fleetId?: string;
    devices?: Array<string>;
};

export type PinnedDeviceDto = {
    fleetId: string;
    devices: Array<string>;
};

export type PrepareSshConnectionRequest = {
    deviceId: string;
    key: string;
    user: string;
};

export type ProblemDetails = {
    type?: null | string;
    title?: null | string;
    status?: null | number | string;
    detail?: null | string;
    instance?: null | string;
};

export type ProvisioningConfig = {
    method?: ProvisioningMethodValue;
    source?: ProvisioningSourceValue;
    x509?: null | CertInfo;
};

export const ProvisioningMethodValue = {
    X509: 'x509',
    SAS: 'sas',
    SYMMETRIC_KEY: 'symmetric_key',
    TPM: 'tpm'
} as const;

export type ProvisioningMethodValue = typeof ProvisioningMethodValue[keyof typeof ProvisioningMethodValue];

export const ProvisioningSourceValue = { DPS: 'dps', MANUAL: 'manual' } as const;

export type ProvisioningSourceValue = typeof ProvisioningSourceValue[keyof typeof ProvisioningSourceValue];

export type RebootStateResponse = {
    isRebooting: boolean;
};

export type ResetPasswordRequest = {
    password: string;
    temporary: boolean;
};

export type RetryUpdateRequest = {
    updateId: UpdateIdDto;
    tag: string;
};

export type RoleMappingInput = {
    id?: null | string;
    name?: null | string;
    description?: null | string;
    composite?: boolean;
    clientRole?: boolean;
    containerId?: null | string;
};

export const SearchFieldType = { EMAIL: 'email' } as const;

export type SearchFieldType = typeof SearchFieldType[keyof typeof SearchFieldType];

export type ServiceBusConfigInfo = {
    namespace: null | string;
    queueName: null | string;
    topicName: null | string;
};

export type SetNotificationSettingsRequest = {
    settings: Array<NotificationSettingItemDto>;
};

export type SshConnectionErrorResponse = {
    called: string;
    internalMsg: string;
    externalMsg: string;
    error: string;
};

export type SshConnectionResponse = {
    uuid: string;
    clientBastionCert: string;
    clientDeviceCert: string;
    host: string;
    port: number | string;
    bastionUser: string;
};

export type StatusResponse = {
    status: string;
};

export type SubscriptionInfoResult = {
    type: string;
    tier: string;
    maxDevices: number | string;
    usedDevices: number | string;
};

export type SwitchTenantRequest = {
    tenant: string;
};

export type SwitchTenantResponse = {
    message: string;
    tenant: string;
};

export const SyncStatus = { SYNCED: 'Synced', SYNC_FAILED: 'SyncFailed' } as const;

export type SyncStatus = typeof SyncStatus[keyof typeof SyncStatus];

export type TemperatureMetric = {
    degreeCelcius?: null | number | string;
};

export type TenantConfigResponse = {
    tenant: string;
    ioTHub: IoTHubConfigInfo;
    serviceBus: null | ServiceBusConfigInfo;
    eventGrid: null | EventGridConfigInfo;
    mongoDb: MongoDbConfigInfo;
    timescaleDb: null | TimescaleDbConfigInfo;
};

export type TenantImageResponse = {
    imageRelativeUrl: string;
};

export type TenantImagesResponse = {
    imageRelativeUrls: Array<string>;
};

export type TenantInfoResponse = {
    currentTenant: string;
    tenantList: Array<string>;
    channelNamespace: string;
};

export type TimescaleDbConfigInfo = {
    databaseName: null | string;
    host: null | string;
    port: null | number | string;
    hasConnectionString: boolean;
};

export type ToggleGeneralConsentRequest = {
    enabled: boolean;
};

export const Topic = {
    FACTORY_RESET: 'FactoryReset',
    OS_IMAGE_GENERATED: 'OsImageGenerated',
    DEVICE_CREATED: 'DeviceCreated',
    DEVICE_UPDATE: 'DeviceUpdate',
    APP_INSTALLATION: 'AppInstallation',
    CERT_EXPIRING: 'CertExpiring',
    APP_RUNTIME_STATE: 'AppRuntimeState',
    IMAGE_RELEASE: 'ImageRelease',
    UNEXPECTED_REBOOT: 'UnexpectedReboot',
    DEVICE_SYNC: 'DeviceSync'
} as const;

export type Topic = typeof Topic[keyof typeof Topic];

export type TraceContext = {
    traceparent?: string;
};

export type UnassignedDevicesResponse = {
    devices?: Array<Device>;
    count?: number | string;
    totalCount?: bigint | string;
};

export type UninstallAppRequest = {
    appName: string;
    fleetIds: Array<string>;
    appTitle?: null | string;
};

export type UpdateAppRequest = {
    appName: string;
    version: string;
    fleetIds: Array<string>;
};

export type UpdateDeploymentStatusResponse = {
    totalDevices?: number | string;
    startDateTime?: null | string;
    devicesInProgressCount?: number | string;
    devicesCompletedFailedCount?: number | string;
    devicesCompletedSucceededCount?: number | string;
    devicesCanceledCount?: number | string;
    devicesWithRequiredConsent?: number | string;
};

export type UpdateGroupResponse = {
    deviceClassId?: string;
    deviceFleetId?: string;
    compatibilityProperties?: CompatibilityPropertiesResponse;
    compatibilityTag?: string;
    updates?: Array<UpdateResponse>;
    hasActiveUpdate?: boolean;
};

export type UpdateId = {
    provider?: string;
    name?: string;
    version?: string;
};

export type UpdateIdDto = {
    provider: string;
    name: string;
    version: string;
};

export type UpdateIdResponse = {
    name?: string;
    provider?: string;
    version?: string;
};

export type UpdateInfo = {
    updateId?: UpdateId;
};

export type UpdateResponse = {
    active?: boolean;
    updateId?: UpdateIdResponse;
    status?: null | UpdateDeploymentStatusResponse;
};

export type UpdateUserRequest = {
    email?: null | string;
    emailVerified?: boolean;
    enabled?: boolean;
    firstName?: null | string;
    lastName?: null | string;
    requiredActions?: null | Array<string>;
    groups?: null | Array<string>;
    roleMapping?: null | Array<RoleMappingInput>;
    attributeMapping?: null | Array<AttributeMappingInput>;
};

export type UpsertUserSettingsRequest = {
    language: null | string;
    pinnedFleets: null | Array<string>;
    pinnedDevices: null | Array<PinnedDeviceDto>;
    fleetsView: null | string;
    notificationsTouched: null | boolean;
};

export type UrlResponse = {
    url: string;
};

export type UserCreatedResponse = {
    userId: string;
};

export type UserFleetsResponse = {
    deviceFleetIds: Array<string>;
};

export type UserSettings = {
    email?: string;
    language?: null | AvailableLanguages;
    pinnedFleets?: Array<string>;
    pinnedDevices?: Array<PinnedDevice>;
    fleetsView?: FleetsView;
    notificationsTouched?: boolean;
    acknowledgedTopics?: Array<Topic>;
    id?: string;
    createdAt?: null | string;
    updatedAt?: null | string;
};

export type VersionUrl = {
    version?: string;
    url?: string;
};

export type VulnerabilityMetric = {
    critical?: number | string;
    high?: number | string;
    medium?: number | string;
    low?: number | string;
    unassigned?: number | string;
    total?: number | string;
    name?: string;
    uuid?: string;
};

export type WelcomeFleetRequest = {
    displayName: string;
    description: null | string;
    supportedDeviceHardwareModels: Array<string>;
    baseDeploymentDisabled?: boolean;
    generalConsent?: boolean;
    resetConsentOnFail?: boolean;
    localWebservice?: boolean;
};

export type WifiCommissioningProperty = {
    version?: number | string;
    bleEnabled?: null | boolean;
    running?: null | boolean;
    interface?: null | string;
};

export type GetUserManagementActionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user-management/actions';
};

export type GetUserManagementActionsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUserManagementActionsError = GetUserManagementActionsErrors[keyof GetUserManagementActionsErrors];

export type GetUserManagementActionsResponses = {
    /**
     * OK
     */
    200: Array<KeycloakRequiredAction>;
};

export type GetUserManagementActionsResponse = GetUserManagementActionsResponses[keyof GetUserManagementActionsResponses];

export type GetUserManagementActionsEnabledData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user-management/actions/enabled';
};

export type GetUserManagementActionsEnabledErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUserManagementActionsEnabledError = GetUserManagementActionsEnabledErrors[keyof GetUserManagementActionsEnabledErrors];

export type GetUserManagementActionsEnabledResponses = {
    /**
     * OK
     */
    200: Array<KeycloakRequiredAction>;
};

export type GetUserManagementActionsEnabledResponse = GetUserManagementActionsEnabledResponses[keyof GetUserManagementActionsEnabledResponses];

export type GetAppsData = {
    body?: never;
    path?: never;
    query?: {
        page?: number | string;
        pageSize?: number | string;
        search?: string;
        orderBy?: string;
        order?: string;
    };
    url: '/apps';
};

export type GetAppsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetAppsError = GetAppsErrors[keyof GetAppsErrors];

export type GetAppsResponses = {
    /**
     * OK
     */
    200: Array<App>;
};

export type GetAppsResponse = GetAppsResponses[keyof GetAppsResponses];

export type GetAppsByAppNameData = {
    body?: never;
    path: {
        appName: string;
    };
    query?: never;
    url: '/apps/{appName}';
};

export type GetAppsByAppNameErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetAppsByAppNameError = GetAppsByAppNameErrors[keyof GetAppsByAppNameErrors];

export type GetAppsByAppNameResponses = {
    /**
     * OK
     */
    200: ApplicationDetailResponse;
};

export type GetAppsByAppNameResponse = GetAppsByAppNameResponses[keyof GetAppsByAppNameResponses];

export type GetAppsByAppIdByVersionReadmeData = {
    body?: never;
    path: {
        appId: string;
        version: string;
    };
    query?: never;
    url: '/apps/{appId}/{version}/readme';
};

export type GetAppsByAppIdByVersionReadmeErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetAppsByAppIdByVersionReadmeError = GetAppsByAppIdByVersionReadmeErrors[keyof GetAppsByAppIdByVersionReadmeErrors];

export type GetAppsByAppIdByVersionReadmeResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetAppsByAppIdByVersionReadmeResponse = GetAppsByAppIdByVersionReadmeResponses[keyof GetAppsByAppIdByVersionReadmeResponses];

export type GetAppsByAppIdByVersionReadmeContentData = {
    body?: never;
    path: {
        appId: string;
        version: string;
    };
    query?: never;
    url: '/apps/{appId}/{version}/readme/content';
};

export type GetAppsByAppIdByVersionReadmeContentErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Bad Gateway
     */
    502: MessageResponse;
};

export type GetAppsByAppIdByVersionReadmeContentError = GetAppsByAppIdByVersionReadmeContentErrors[keyof GetAppsByAppIdByVersionReadmeContentErrors];

export type GetAppsByAppIdByVersionReadmeContentResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetAppsByAppIdByVersionReadmeContentResponse = GetAppsByAppIdByVersionReadmeContentResponses[keyof GetAppsByAppIdByVersionReadmeContentResponses];

export type GetAppsByAppIdByVersionChangelogContentData = {
    body?: never;
    path: {
        appId: string;
        version: string;
    };
    query?: never;
    url: '/apps/{appId}/{version}/changelog/content';
};

export type GetAppsByAppIdByVersionChangelogContentErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Bad Gateway
     */
    502: MessageResponse;
};

export type GetAppsByAppIdByVersionChangelogContentError = GetAppsByAppIdByVersionChangelogContentErrors[keyof GetAppsByAppIdByVersionChangelogContentErrors];

export type GetAppsByAppIdByVersionChangelogContentResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetAppsByAppIdByVersionChangelogContentResponse = GetAppsByAppIdByVersionChangelogContentResponses[keyof GetAppsByAppIdByVersionChangelogContentResponses];

export type GetAppsByAppIdByVersionChangelogData = {
    body?: never;
    path: {
        appId: string;
        version: string;
    };
    query?: never;
    url: '/apps/{appId}/{version}/changelog';
};

export type GetAppsByAppIdByVersionChangelogErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetAppsByAppIdByVersionChangelogError = GetAppsByAppIdByVersionChangelogErrors[keyof GetAppsByAppIdByVersionChangelogErrors];

export type GetAppsByAppIdByVersionChangelogResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetAppsByAppIdByVersionChangelogResponse = GetAppsByAppIdByVersionChangelogResponses[keyof GetAppsByAppIdByVersionChangelogResponses];

export type PostAppsInstallData = {
    body: InstallAppRequest;
    path?: never;
    query?: never;
    url: '/apps/install';
};

export type PostAppsInstallErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostAppsInstallError = PostAppsInstallErrors[keyof PostAppsInstallErrors];

export type PostAppsInstallResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostAppsUpdateData = {
    body: UpdateAppRequest;
    path?: never;
    query?: never;
    url: '/apps/update';
};

export type PostAppsUpdateErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostAppsUpdateError = PostAppsUpdateErrors[keyof PostAppsUpdateErrors];

export type PostAppsUpdateResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostAppsUninstallData = {
    body: UninstallAppRequest;
    path?: never;
    query?: never;
    url: '/apps/uninstall';
};

export type PostAppsUninstallErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostAppsUninstallError = PostAppsUninstallErrors[keyof PostAppsUninstallErrors];

export type PostAppsUninstallResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetAppsByAppIdByVersionLegalNoticeData = {
    body?: never;
    path: {
        appId: string;
        version: string;
    };
    query?: {
        tenant?: string;
    };
    url: '/apps/{appId}/{version}/legal-notice';
};

export type GetAppsByAppIdByVersionLegalNoticeErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetAppsByAppIdByVersionLegalNoticeError = GetAppsByAppIdByVersionLegalNoticeErrors[keyof GetAppsByAppIdByVersionLegalNoticeErrors];

export type GetAppsByAppIdByVersionLegalNoticeResponses = {
    /**
     * OK
     */
    200: UrlResponse;
};

export type GetAppsByAppIdByVersionLegalNoticeResponse = GetAppsByAppIdByVersionLegalNoticeResponses[keyof GetAppsByAppIdByVersionLegalNoticeResponses];

export type GetAppsTasksSyncData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/appsTasks/sync';
};

export type GetAppsTasksSyncResponses = {
    /**
     * Accepted
     */
    202: MessageResponse;
};

export type GetAppsTasksSyncResponse = GetAppsTasksSyncResponses[keyof GetAppsTasksSyncResponses];

export type GetChannelsTokenFleetByFleetIdData = {
    body?: never;
    path: {
        fleetId: string;
    };
    query?: never;
    url: '/channels/token/fleet/{fleetId}';
};

export type GetChannelsTokenFleetByFleetIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenFleetByFleetIdError = GetChannelsTokenFleetByFleetIdErrors[keyof GetChannelsTokenFleetByFleetIdErrors];

export type GetChannelsTokenFleetByFleetIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenFleetByFleetIdResponse = GetChannelsTokenFleetByFleetIdResponses[keyof GetChannelsTokenFleetByFleetIdResponses];

export type GetChannelsTokenDeviceByDeviceIdData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/channels/token/device/{deviceId}';
};

export type GetChannelsTokenDeviceByDeviceIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenDeviceByDeviceIdError = GetChannelsTokenDeviceByDeviceIdErrors[keyof GetChannelsTokenDeviceByDeviceIdErrors];

export type GetChannelsTokenDeviceByDeviceIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenDeviceByDeviceIdResponse = GetChannelsTokenDeviceByDeviceIdResponses[keyof GetChannelsTokenDeviceByDeviceIdResponses];

export type GetChannelsTokenDevicecreateByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/channels/token/devicecreate/{id}';
};

export type GetChannelsTokenDevicecreateByIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenDevicecreateByIdError = GetChannelsTokenDevicecreateByIdErrors[keyof GetChannelsTokenDevicecreateByIdErrors];

export type GetChannelsTokenDevicecreateByIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenDevicecreateByIdResponse = GetChannelsTokenDevicecreateByIdResponses[keyof GetChannelsTokenDevicecreateByIdResponses];

export type GetChannelsTokenAppByAppIdData = {
    body?: never;
    path: {
        appId: string;
    };
    query?: never;
    url: '/channels/token/app/{appId}';
};

export type GetChannelsTokenAppByAppIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenAppByAppIdError = GetChannelsTokenAppByAppIdErrors[keyof GetChannelsTokenAppByAppIdErrors];

export type GetChannelsTokenAppByAppIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenAppByAppIdResponse = GetChannelsTokenAppByAppIdResponses[keyof GetChannelsTokenAppByAppIdResponses];

export type GetChannelsTokenOsgenByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/channels/token/osgen/{id}';
};

export type GetChannelsTokenOsgenByIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenOsgenByIdError = GetChannelsTokenOsgenByIdErrors[keyof GetChannelsTokenOsgenByIdErrors];

export type GetChannelsTokenOsgenByIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenOsgenByIdResponse = GetChannelsTokenOsgenByIdResponses[keyof GetChannelsTokenOsgenByIdResponses];

export type GetChannelsTokenNotificationsByRequestedTenantData = {
    body?: never;
    path: {
        requestedTenant: string;
    };
    query?: never;
    url: '/channels/token/notifications/{requestedTenant}';
};

export type GetChannelsTokenNotificationsByRequestedTenantErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenNotificationsByRequestedTenantError = GetChannelsTokenNotificationsByRequestedTenantErrors[keyof GetChannelsTokenNotificationsByRequestedTenantErrors];

export type GetChannelsTokenNotificationsByRequestedTenantResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenNotificationsByRequestedTenantResponse = GetChannelsTokenNotificationsByRequestedTenantResponses[keyof GetChannelsTokenNotificationsByRequestedTenantResponses];

export type GetChannelsTokenMetricByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/channels/token/metric/{id}';
};

export type GetChannelsTokenMetricByIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenMetricByIdError = GetChannelsTokenMetricByIdErrors[keyof GetChannelsTokenMetricByIdErrors];

export type GetChannelsTokenMetricByIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenMetricByIdResponse = GetChannelsTokenMetricByIdResponses[keyof GetChannelsTokenMetricByIdResponses];

export type GetChannelsTokenUpdateGroupByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/channels/token/updateGroup/{id}';
};

export type GetChannelsTokenUpdateGroupByIdErrors = {
    /**
     * Unauthorized
     */
    401: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetChannelsTokenUpdateGroupByIdError = GetChannelsTokenUpdateGroupByIdErrors[keyof GetChannelsTokenUpdateGroupByIdErrors];

export type GetChannelsTokenUpdateGroupByIdResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetChannelsTokenUpdateGroupByIdResponse = GetChannelsTokenUpdateGroupByIdResponses[keyof GetChannelsTokenUpdateGroupByIdResponses];

export type GetConfigCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/Config/current';
};

export type GetConfigCurrentErrors = {
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetConfigCurrentError = GetConfigCurrentErrors[keyof GetConfigCurrentErrors];

export type GetConfigCurrentResponses = {
    /**
     * OK
     */
    200: TenantConfigResponse;
};

export type GetConfigCurrentResponse = GetConfigCurrentResponses[keyof GetConfigCurrentResponses];

export type GetConfigTenantByTenantData = {
    body?: never;
    path: {
        tenant: string;
    };
    query?: never;
    url: '/Config/tenant/{tenant}';
};

export type GetConfigTenantByTenantErrors = {
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetConfigTenantByTenantError = GetConfigTenantByTenantErrors[keyof GetConfigTenantByTenantErrors];

export type GetConfigTenantByTenantResponses = {
    /**
     * OK
     */
    200: TenantConfigResponse;
};

export type GetConfigTenantByTenantResponse = GetConfigTenantByTenantResponses[keyof GetConfigTenantByTenantResponses];

export type GetDevicesHardwareModelsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/devices/hardwareModels';
};

export type GetDevicesHardwareModelsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesHardwareModelsResponses = {
    /**
     * OK
     */
    200: Array<DeviceHardwareModel>;
};

export type GetDevicesHardwareModelsResponse = GetDevicesHardwareModelsResponses[keyof GetDevicesHardwareModelsResponses];

export type GetDevicesUnassignedData = {
    body?: never;
    path?: never;
    query?: {
        page?: number | string;
        pageSize?: number | string;
        search?: string;
        orderBy?: string;
        order?: string;
    };
    url: '/devices/unassigned';
};

export type GetDevicesUnassignedErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesUnassignedResponses = {
    /**
     * OK
     */
    200: UnassignedDevicesResponse;
};

export type GetDevicesUnassignedResponse = GetDevicesUnassignedResponses[keyof GetDevicesUnassignedResponses];

export type GetDevicesByFleetIdData = {
    body?: never;
    path: {
        fleetId: string;
    };
    query?: {
        page?: number | string;
        pageSize?: number | string;
        search?: string;
        orderBy?: string;
        order?: string;
        filter?: string;
    };
    url: '/devices/{fleetId}';
};

export type GetDevicesByFleetIdErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetDevicesByFleetIdError = GetDevicesByFleetIdErrors[keyof GetDevicesByFleetIdErrors];

export type GetDevicesByFleetIdResponses = {
    /**
     * OK
     */
    200: DevicesResponse;
};

export type GetDevicesByFleetIdResponse = GetDevicesByFleetIdResponses[keyof GetDevicesByFleetIdResponses];

export type GetDevicesByDeviceIdGetData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/get';
};

export type GetDevicesByDeviceIdGetErrors = {
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesByDeviceIdGetError = GetDevicesByDeviceIdGetErrors[keyof GetDevicesByDeviceIdGetErrors];

export type GetDevicesByDeviceIdGetResponses = {
    /**
     * OK
     */
    200: Device;
};

export type GetDevicesByDeviceIdGetResponse = GetDevicesByDeviceIdGetResponses[keyof GetDevicesByDeviceIdGetResponses];

export type GetDevicesByDeviceIdMetricsData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/metrics';
};

export type GetDevicesByDeviceIdMetricsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesByDeviceIdMetricsResponses = {
    /**
     * OK
     */
    200: DeviceMetricResponse;
};

export type GetDevicesByDeviceIdMetricsResponse = GetDevicesByDeviceIdMetricsResponses[keyof GetDevicesByDeviceIdMetricsResponses];

export type GetDevicesByDeviceIdAppsData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/apps';
};

export type GetDevicesByDeviceIdAppsErrors = {
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesByDeviceIdAppsError = GetDevicesByDeviceIdAppsErrors[keyof GetDevicesByDeviceIdAppsErrors];

export type GetDevicesByDeviceIdAppsResponses = {
    /**
     * OK
     */
    200: Array<DeviceApplicationResponse>;
};

export type GetDevicesByDeviceIdAppsResponse = GetDevicesByDeviceIdAppsResponses[keyof GetDevicesByDeviceIdAppsResponses];

export type GetDevicesByDeviceIdEventsData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: {
        page?: number | string;
        pageSize?: number | string;
        orderBy?: string;
        order?: string;
        filterType?: string;
    };
    url: '/devices/{deviceId}/events';
};

export type GetDevicesByDeviceIdEventsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesByDeviceIdEventsResponses = {
    /**
     * OK
     */
    200: EventListResponse;
};

export type GetDevicesByDeviceIdEventsResponse = GetDevicesByDeviceIdEventsResponses[keyof GetDevicesByDeviceIdEventsResponses];

export type GetDevicesByDeviceIdRebootstateData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/rebootstate';
};

export type GetDevicesByDeviceIdRebootstateErrors = {
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetDevicesByDeviceIdRebootstateError = GetDevicesByDeviceIdRebootstateErrors[keyof GetDevicesByDeviceIdRebootstateErrors];

export type GetDevicesByDeviceIdRebootstateResponses = {
    /**
     * OK
     */
    200: RebootStateResponse;
};

export type GetDevicesByDeviceIdRebootstateResponse = GetDevicesByDeviceIdRebootstateResponses[keyof GetDevicesByDeviceIdRebootstateResponses];

export type PostDevicesDeleteListData = {
    body: DeleteDevicesRequest;
    path?: never;
    query?: never;
    url: '/devices/delete-list';
};

export type PostDevicesDeleteListErrors = {
    /**
     * Bad Request
     */
    400: DeviceDeleteResponse;
};

export type PostDevicesDeleteListError = PostDevicesDeleteListErrors[keyof PostDevicesDeleteListErrors];

export type PostDevicesDeleteListResponses = {
    /**
     * OK
     */
    200: DeviceDeleteResponse;
};

export type PostDevicesDeleteListResponse = PostDevicesDeleteListResponses[keyof PostDevicesDeleteListResponses];

export type PostDevicesMoveListData = {
    body: MoveDevicesRequest;
    path?: never;
    query?: never;
    url: '/devices/move-list';
};

export type PostDevicesMoveListErrors = {
    /**
     * Bad Request
     */
    400: ProblemDetails;
};

export type PostDevicesMoveListError = PostDevicesMoveListErrors[keyof PostDevicesMoveListErrors];

export type PostDevicesMoveListResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostDevicesImageCreateData = {
    body: GenerateOsImageRequest;
    path?: never;
    query?: never;
    url: '/devices/image/create';
};

export type PostDevicesImageCreateErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesImageCreateResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostDevicesPrepareSshConnectionData = {
    body: PrepareSshConnectionRequest;
    path?: never;
    query?: never;
    url: '/devices/prepareSSHConnection';
};

export type PostDevicesPrepareSshConnectionErrors = {
    /**
     * Internal Server Error
     */
    500: SshConnectionErrorResponse;
};

export type PostDevicesPrepareSshConnectionError = PostDevicesPrepareSshConnectionErrors[keyof PostDevicesPrepareSshConnectionErrors];

export type PostDevicesPrepareSshConnectionResponses = {
    /**
     * OK
     */
    200: SshConnectionResponse;
};

export type PostDevicesPrepareSshConnectionResponse = PostDevicesPrepareSshConnectionResponses[keyof PostDevicesPrepareSshConnectionResponses];

export type PostDevicesByDeviceIdFirmwareConsentData = {
    body: ApplyFirmwareConsentRequest;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/firmware-consent';
};

export type PostDevicesByDeviceIdFirmwareConsentErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdFirmwareConsentResponses = {
    /**
     * OK
     */
    200: DeviceMethodResult;
};

export type PostDevicesByDeviceIdFirmwareConsentResponse = PostDevicesByDeviceIdFirmwareConsentResponses[keyof PostDevicesByDeviceIdFirmwareConsentResponses];

export type PostDevicesByDeviceIdFactoryresetData = {
    body: FactoryResetRequest;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/factoryreset';
};

export type PostDevicesByDeviceIdFactoryresetErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdFactoryresetResponses = {
    /**
     * OK
     */
    200: DeviceMethodResult;
};

export type PostDevicesByDeviceIdFactoryresetResponse = PostDevicesByDeviceIdFactoryresetResponses[keyof PostDevicesByDeviceIdFactoryresetResponses];

export type PostDevicesByDeviceIdAppConsentData = {
    body: AppConsentRequest;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/app-consent';
};

export type PostDevicesByDeviceIdAppConsentErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdAppConsentResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostDevicesByDeviceIdNetworkRefreshData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/network/refresh';
};

export type PostDevicesByDeviceIdNetworkRefreshErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdNetworkRefreshResponses = {
    /**
     * OK
     */
    200: DeviceMethodResult;
};

export type PostDevicesByDeviceIdNetworkRefreshResponse = PostDevicesByDeviceIdNetworkRefreshResponses[keyof PostDevicesByDeviceIdNetworkRefreshResponses];

export type PostDevicesByDeviceIdRebootData = {
    body?: never;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/reboot';
};

export type PostDevicesByDeviceIdRebootErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdRebootResponses = {
    /**
     * OK
     */
    200: DeviceMethodResult;
};

export type PostDevicesByDeviceIdRebootResponse = PostDevicesByDeviceIdRebootResponses[keyof PostDevicesByDeviceIdRebootResponses];

export type PostDevicesByDeviceIdGeneralConsentToggleData = {
    body: ToggleGeneralConsentRequest;
    path: {
        deviceId: string;
    };
    query?: never;
    url: '/devices/{deviceId}/general-consent/toggle';
};

export type PostDevicesByDeviceIdGeneralConsentToggleErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdGeneralConsentToggleResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostDevicesByDeviceIdByModuleRestartData = {
    body?: never;
    path: {
        deviceId: string;
        module: string;
    };
    query?: never;
    url: '/devices/{deviceId}/{module}/restart';
};

export type PostDevicesByDeviceIdByModuleRestartErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostDevicesByDeviceIdByModuleRestartResponses = {
    /**
     * OK
     */
    200: DeviceMethodResult;
};

export type PostDevicesByDeviceIdByModuleRestartResponse = PostDevicesByDeviceIdByModuleRestartResponses[keyof PostDevicesByDeviceIdByModuleRestartResponses];

export type GetDeviceTasksSyncData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/deviceTasks/sync';
};

export type GetDeviceTasksSyncResponses = {
    /**
     * Accepted
     */
    202: MessageResponse;
};

export type GetDeviceTasksSyncResponse = GetDeviceTasksSyncResponses[keyof GetDeviceTasksSyncResponses];

export type GetDeviceTasksCertcheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/deviceTasks/certcheck';
};

export type GetDeviceTasksCertcheckResponses = {
    /**
     * Accepted
     */
    202: MessageResponse;
};

export type GetDeviceTasksCertcheckResponse = GetDeviceTasksCertcheckResponses[keyof GetDeviceTasksCertcheckResponses];

export type GetEventsData = {
    body?: never;
    path?: never;
    query?: {
        Page?: number | string;
        PageSize?: number | string;
        Search?: string;
        OrderBy?: string;
        Order?: Order;
        FilterTypes?: Array<string>;
    };
    url: '/events';
};

export type GetEventsErrors = {
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetEventsResponses = {
    /**
     * OK
     */
    200: EventListResponse;
};

export type GetEventsResponse = GetEventsResponses[keyof GetEventsResponses];

export type GetEventsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/events/{id}';
};

export type GetEventsByIdErrors = {
    /**
     * Not Found
     */
    404: ProblemDetails;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type GetEventsByIdError = GetEventsByIdErrors[keyof GetEventsByIdErrors];

export type GetEventsByIdResponses = {
    /**
     * OK
     */
    200: EventDto;
};

export type GetEventsByIdResponse = GetEventsByIdResponses[keyof GetEventsByIdResponses];

export type PostFirmwareAduImportData = {
    body: ImportFirmwareRequest;
    path?: never;
    query?: never;
    url: '/firmware/adu-import';
};

export type PostFirmwareAduImportErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type PostFirmwareAduImportError = PostFirmwareAduImportErrors[keyof PostFirmwareAduImportErrors];

export type PostFirmwareAduImportResponses = {
    /**
     * Created
     */
    201: StatusResponse;
};

export type PostFirmwareAduImportResponse = PostFirmwareAduImportResponses[keyof PostFirmwareAduImportResponses];

export type GetFirmwareContainersByFleetIdOrHardwareModelData = {
    body?: never;
    path: {
        fleetIdOrHardwareModel: string;
    };
    query?: {
        firmwareContainerQueryType?: string;
    };
    url: '/firmware/containers/{fleetIdOrHardwareModel}';
};

export type GetFirmwareContainersByFleetIdOrHardwareModelErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetFirmwareContainersByFleetIdOrHardwareModelError = GetFirmwareContainersByFleetIdOrHardwareModelErrors[keyof GetFirmwareContainersByFleetIdOrHardwareModelErrors];

export type GetFirmwareContainersByFleetIdOrHardwareModelResponses = {
    /**
     * OK
     */
    200: Array<FirmwareContainer>;
};

export type GetFirmwareContainersByFleetIdOrHardwareModelResponse = GetFirmwareContainersByFleetIdOrHardwareModelResponses[keyof GetFirmwareContainersByFleetIdOrHardwareModelResponses];

export type GetFirmwareByVersionReleaseNotesData = {
    body?: never;
    path: {
        version: string;
    };
    query?: never;
    url: '/firmware/{version}/release-notes';
};

export type GetFirmwareByVersionReleaseNotesErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetFirmwareByVersionReleaseNotesError = GetFirmwareByVersionReleaseNotesErrors[keyof GetFirmwareByVersionReleaseNotesErrors];

export type GetFirmwareByVersionReleaseNotesResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetFirmwareByVersionReleaseNotesResponse = GetFirmwareByVersionReleaseNotesResponses[keyof GetFirmwareByVersionReleaseNotesResponses];

export type GetFirmwareByVersionLegalNoticesData = {
    body?: never;
    path: {
        version: string;
    };
    query?: {
        tenant?: string;
    };
    url: '/firmware/{version}/legal-notices';
};

export type GetFirmwareByVersionLegalNoticesErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetFirmwareByVersionLegalNoticesError = GetFirmwareByVersionLegalNoticesErrors[keyof GetFirmwareByVersionLegalNoticesErrors];

export type GetFirmwareByVersionLegalNoticesResponses = {
    /**
     * OK
     */
    200: UrlResponse;
};

export type GetFirmwareByVersionLegalNoticesResponse = GetFirmwareByVersionLegalNoticesResponses[keyof GetFirmwareByVersionLegalNoticesResponses];

export type GetFleetsFleetExistsData = {
    body?: never;
    path?: never;
    query?: {
        fleet?: string;
    };
    url: '/fleets/fleetExists';
};

export type GetFleetsFleetExistsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetFleetsFleetExistsError = GetFleetsFleetExistsErrors[keyof GetFleetsFleetExistsErrors];

export type GetFleetsFleetExistsResponses = {
    /**
     * OK
     */
    200: null | number | string;
};

export type GetFleetsFleetExistsResponse = GetFleetsFleetExistsResponses[keyof GetFleetsFleetExistsResponses];

export type GetFleetsInfoData = {
    body?: never;
    path?: never;
    query?: {
        page?: number | string;
        itemsPerPage?: number | string;
        search?: string;
        orderBy?: string;
        order?: string;
    };
    url: '/fleets/info';
};

export type GetFleetsInfoErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetFleetsInfoError = GetFleetsInfoErrors[keyof GetFleetsInfoErrors];

export type GetFleetsInfoResponses = {
    /**
     * OK
     */
    200: PaginatedResponseOfFleet;
};

export type GetFleetsInfoResponse = GetFleetsInfoResponses[keyof GetFleetsInfoResponses];

export type PostFleetsCreateData = {
    body: {
        DisplayName?: string;
        Description?: string;
        'supportedDeviceHardwareModels[]'?: Array<string>;
        'userEmails[]'?: Array<string>;
        BaseDeploymentDisabled?: boolean;
        GeneralConsent?: boolean;
        ResetConsentOnFail?: boolean;
        LocalWebservice?: boolean;
        File?: IFormFile;
    };
    path?: never;
    query?: never;
    url: '/fleets/create';
};

export type PostFleetsCreateErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Conflict
     */
    409: MessageResponse;
};

export type PostFleetsCreateError = PostFleetsCreateErrors[keyof PostFleetsCreateErrors];

export type PostFleetsCreateResponses = {
    /**
     * Created
     */
    201: FleetCreatedResponse;
};

export type PostFleetsCreateResponse = PostFleetsCreateResponses[keyof PostFleetsCreateResponses];

export type PostFleetsWelcomeData = {
    body: WelcomeFleetRequest;
    path?: never;
    query?: never;
    url: '/fleets/welcome';
};

export type PostFleetsWelcomeErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type PostFleetsWelcomeError = PostFleetsWelcomeErrors[keyof PostFleetsWelcomeErrors];

export type PostFleetsWelcomeResponses = {
    /**
     * Created
     */
    201: FleetCreatedResponse;
};

export type PostFleetsWelcomeResponse = PostFleetsWelcomeResponses[keyof PostFleetsWelcomeResponses];

export type PutFleetsUpdateData = {
    body: {
        FleetId?: string;
        DisplayName?: string;
        Description?: string;
        'supportedDeviceHardwareModels[]'?: Array<string>;
        'userEmails[]'?: Array<string>;
        BaseDeploymentDisabled?: boolean;
        GeneralConsent?: boolean;
        ResetConsentOnFail?: boolean;
        LocalWebservice?: boolean;
        RemoveImage?: boolean;
        File?: IFormFile;
    };
    path?: never;
    query?: never;
    url: '/fleets/update';
};

export type PutFleetsUpdateErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PutFleetsUpdateError = PutFleetsUpdateErrors[keyof PutFleetsUpdateErrors];

export type PutFleetsUpdateResponses = {
    /**
     * OK
     */
    200: FleetUpdatedResponse;
};

export type PutFleetsUpdateResponse = PutFleetsUpdateResponses[keyof PutFleetsUpdateResponses];

export type PostFleetsDeleteListData = {
    body: DeleteFleetsRequest;
    path?: never;
    query?: never;
    url: '/fleets/deleteList';
};

export type PostFleetsDeleteListResponses = {
    /**
     * OK
     */
    200: BulkDeleteResponse;
};

export type PostFleetsDeleteListResponse = PostFleetsDeleteListResponses[keyof PostFleetsDeleteListResponses];

export type GetFleetsByFleetIdData = {
    body?: never;
    path: {
        fleetId: string;
    };
    query?: never;
    url: '/fleets/{fleetId}';
};

export type GetFleetsByFleetIdErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetFleetsByFleetIdError = GetFleetsByFleetIdErrors[keyof GetFleetsByFleetIdErrors];

export type GetFleetsByFleetIdResponses = {
    /**
     * OK
     */
    200: FleetDetailResponse;
};

export type GetFleetsByFleetIdResponse = GetFleetsByFleetIdResponses[keyof GetFleetsByFleetIdResponses];

export type GetFleetsByFleetIdUpdatesData = {
    body?: never;
    path: {
        fleetId: string;
    };
    query?: never;
    url: '/fleets/{fleetId}/updates';
};

export type GetFleetsByFleetIdUpdatesErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetFleetsByFleetIdUpdatesError = GetFleetsByFleetIdUpdatesErrors[keyof GetFleetsByFleetIdUpdatesErrors];

export type GetFleetsByFleetIdUpdatesResponses = {
    /**
     * OK
     */
    200: Array<UpdateGroupResponse>;
};

export type GetFleetsByFleetIdUpdatesResponse = GetFleetsByFleetIdUpdatesResponses[keyof GetFleetsByFleetIdUpdatesResponses];

export type GetFleetsCompatibleFleetsData = {
    body?: never;
    path?: never;
    query?: {
        hardwareModels?: Array<string>;
    };
    url: '/fleets/compatible-fleets';
};

export type GetFleetsCompatibleFleetsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetFleetsCompatibleFleetsError = GetFleetsCompatibleFleetsErrors[keyof GetFleetsCompatibleFleetsErrors];

export type GetFleetsCompatibleFleetsResponses = {
    /**
     * OK
     */
    200: Array<Fleet>;
};

export type GetFleetsCompatibleFleetsResponse = GetFleetsCompatibleFleetsResponses[keyof GetFleetsCompatibleFleetsResponses];

export type GetFleetsByFleetIdCompatibleFleetsData = {
    body?: never;
    path: {
        fleetId: string;
    };
    query?: {
        hardwareModels?: Array<string>;
    };
    url: '/fleets/{fleetId}/compatible-fleets';
};

export type GetFleetsByFleetIdCompatibleFleetsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetFleetsByFleetIdCompatibleFleetsError = GetFleetsByFleetIdCompatibleFleetsErrors[keyof GetFleetsByFleetIdCompatibleFleetsErrors];

export type GetFleetsByFleetIdCompatibleFleetsResponses = {
    /**
     * OK
     */
    200: Array<Fleet>;
};

export type GetFleetsByFleetIdCompatibleFleetsResponse = GetFleetsByFleetIdCompatibleFleetsResponses[keyof GetFleetsByFleetIdCompatibleFleetsResponses];

export type GetFleetTasksSyncData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/fleetTasks/sync';
};

export type GetFleetTasksSyncResponses = {
    /**
     * Accepted
     */
    202: MessageResponse;
};

export type GetFleetTasksSyncResponse = GetFleetTasksSyncResponses[keyof GetFleetTasksSyncResponses];

export type DeleteFleetTasksDeleteEmptyDeviceClassesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/fleetTasks/deleteEmptyDeviceClasses';
};

export type DeleteFleetTasksDeleteEmptyDeviceClassesResponses = {
    /**
     * Accepted
     */
    202: MessageResponse;
};

export type DeleteFleetTasksDeleteEmptyDeviceClassesResponse = DeleteFleetTasksDeleteEmptyDeviceClassesResponses[keyof DeleteFleetTasksDeleteEmptyDeviceClassesResponses];

export type GetUserManagementGroupsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user-management/groups';
};

export type GetUserManagementGroupsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUserManagementGroupsError = GetUserManagementGroupsErrors[keyof GetUserManagementGroupsErrors];

export type GetUserManagementGroupsResponses = {
    /**
     * OK
     */
    200: Array<KeycloakGroup>;
};

export type GetUserManagementGroupsResponse = GetUserManagementGroupsResponses[keyof GetUserManagementGroupsResponses];

export type GetUserManagementGroupsByGroupIdData = {
    body?: never;
    path: {
        groupId: string;
    };
    query?: never;
    url: '/user-management/groups/{groupId}';
};

export type GetUserManagementGroupsByGroupIdErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetUserManagementGroupsByGroupIdError = GetUserManagementGroupsByGroupIdErrors[keyof GetUserManagementGroupsByGroupIdErrors];

export type GetUserManagementGroupsByGroupIdResponses = {
    /**
     * OK
     */
    200: KeycloakGroup;
};

export type GetUserManagementGroupsByGroupIdResponse = GetUserManagementGroupsByGroupIdResponses[keyof GetUserManagementGroupsByGroupIdResponses];

export type GetHealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/Health';
};

export type GetHealthResponses = {
    /**
     * OK
     */
    200: HealthResponse;
};

export type GetHealthResponse = GetHealthResponses[keyof GetHealthResponses];

export type GetHealthTenantData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/Health/tenant';
};

export type GetHealthTenantResponses = {
    /**
     * OK
     */
    200: TenantInfoResponse;
};

export type GetHealthTenantResponse = GetHealthTenantResponses[keyof GetHealthTenantResponses];

export type GetHealthMongodbData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/Health/mongodb';
};

export type GetHealthMongodbErrors = {
    /**
     * Service Unavailable
     */
    503: unknown;
};

export type GetHealthMongodbResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetHealthTimescaledbData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/Health/timescaledb';
};

export type GetHealthTimescaledbErrors = {
    /**
     * Service Unavailable
     */
    503: unknown;
};

export type GetHealthTimescaledbResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetHealthBastionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/Health/bastion';
};

export type GetHealthBastionErrors = {
    /**
     * Service Unavailable
     */
    503: unknown;
};

export type GetHealthBastionResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetImagesGetByFolderByTenantByFileNameData = {
    body?: never;
    path: {
        folder: string;
        tenant: string;
        fileName: string;
    };
    query?: never;
    url: '/images/get/{folder}/{tenant}/{fileName}';
};

export type GetImagesGetByFolderByTenantByFileNameErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetImagesGetByFolderByTenantByFileNameError = GetImagesGetByFolderByTenantByFileNameErrors[keyof GetImagesGetByFolderByTenantByFileNameErrors];

export type GetImagesGetByFolderByTenantByFileNameResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetImagesGetByFolderByFileNameData = {
    body?: never;
    path: {
        folder: string;
        fileName: string;
    };
    query?: never;
    url: '/images/get/{folder}/{fileName}';
};

export type GetImagesGetByFolderByFileNameErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: MessageResponse;
};

export type GetImagesGetByFolderByFileNameError = GetImagesGetByFolderByFileNameErrors[keyof GetImagesGetByFolderByFileNameErrors];

export type GetImagesGetByFolderByFileNameResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetMetricsTasksCollectData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/metricsTasks/collect';
};

export type GetMetricsTasksCollectResponses = {
    /**
     * Accepted
     */
    202: MessageResponse;
};

export type GetMetricsTasksCollectResponse = GetMetricsTasksCollectResponses[keyof GetMetricsTasksCollectResponses];

export type PostOsgenReportSuccessData = {
    body: OsGenReportSuccessRequest;
    path?: never;
    query?: never;
    url: '/osgen/reportSuccess';
};

export type PostOsgenReportSuccessErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostOsgenReportSuccessError = PostOsgenReportSuccessErrors[keyof PostOsgenReportSuccessErrors];

export type PostOsgenReportSuccessResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type PostOsgenReportSuccessResponse = PostOsgenReportSuccessResponses[keyof PostOsgenReportSuccessResponses];

export type PostOsgenReportFailedData = {
    body: OsGenReportFailedRequest;
    path?: never;
    query?: never;
    url: '/osgen/reportFailed';
};

export type PostOsgenReportFailedErrors = {
    /**
     * Not Found
     */
    404: MessageResponse;
    /**
     * Internal Server Error
     */
    500: unknown;
};

export type PostOsgenReportFailedError = PostOsgenReportFailedErrors[keyof PostOsgenReportFailedErrors];

export type PostOsgenReportFailedResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type PostOsgenReportFailedResponse = PostOsgenReportFailedResponses[keyof PostOsgenReportFailedResponses];

export type GetUserManagementRolesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user-management/roles';
};

export type GetUserManagementRolesErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUserManagementRolesError = GetUserManagementRolesErrors[keyof GetUserManagementRolesErrors];

export type GetUserManagementRolesResponses = {
    /**
     * OK
     */
    200: Array<KeycloakRole>;
};

export type GetUserManagementRolesResponse = GetUserManagementRolesResponses[keyof GetUserManagementRolesResponses];

export type GetSubscriptionInfoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/subscription-info';
};

export type GetSubscriptionInfoErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetSubscriptionInfoError = GetSubscriptionInfoErrors[keyof GetSubscriptionInfoErrors];

export type GetSubscriptionInfoResponses = {
    /**
     * OK
     */
    200: SubscriptionInfoResult;
};

export type GetSubscriptionInfoResponse = GetSubscriptionInfoResponses[keyof GetSubscriptionInfoResponses];

export type PostUpdatesByFleetIdInstallData = {
    body: InstallUpdateRequest;
    path: {
        fleetId: string;
    };
    query?: never;
    url: '/updates/{fleetId}/install';
};

export type PostUpdatesByFleetIdInstallErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostUpdatesByFleetIdInstallError = PostUpdatesByFleetIdInstallErrors[keyof PostUpdatesByFleetIdInstallErrors];

export type PostUpdatesByFleetIdInstallResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type PostUpdatesByFleetIdInstallResponse = PostUpdatesByFleetIdInstallResponses[keyof PostUpdatesByFleetIdInstallResponses];

export type PostUpdatesByFleetIdRetryData = {
    body: RetryUpdateRequest;
    path: {
        fleetId: string;
    };
    query?: never;
    url: '/updates/{fleetId}/retry';
};

export type PostUpdatesByFleetIdRetryErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostUpdatesByFleetIdRetryError = PostUpdatesByFleetIdRetryErrors[keyof PostUpdatesByFleetIdRetryErrors];

export type PostUpdatesByFleetIdRetryResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type PostUpdatesByFleetIdRetryResponse = PostUpdatesByFleetIdRetryResponses[keyof PostUpdatesByFleetIdRetryResponses];

export type PostUpdatesByFleetIdCancelData = {
    body: CancelUpdateRequest;
    path: {
        fleetId: string;
    };
    query?: never;
    url: '/updates/{fleetId}/cancel';
};

export type PostUpdatesByFleetIdCancelErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostUpdatesByFleetIdCancelError = PostUpdatesByFleetIdCancelErrors[keyof PostUpdatesByFleetIdCancelErrors];

export type PostUpdatesByFleetIdCancelResponses = {
    /**
     * OK
     */
    200: boolean;
};

export type PostUpdatesByFleetIdCancelResponse = PostUpdatesByFleetIdCancelResponses[keyof PostUpdatesByFleetIdCancelResponses];

export type GetUsersFleetsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/fleets';
};

export type GetUsersFleetsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUsersFleetsError = GetUsersFleetsErrors[keyof GetUsersFleetsErrors];

export type GetUsersFleetsResponses = {
    /**
     * OK
     */
    200: UserFleetsResponse;
};

export type GetUsersFleetsResponse = GetUsersFleetsResponses[keyof GetUsersFleetsResponses];

export type GetUserManagementUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/user-management/user';
};

export type GetUserManagementUserErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUserManagementUserError = GetUserManagementUserErrors[keyof GetUserManagementUserErrors];

export type GetUserManagementUserResponses = {
    /**
     * OK
     */
    200: Array<EnrichedUser>;
};

export type GetUserManagementUserResponse = GetUserManagementUserResponses[keyof GetUserManagementUserResponses];

export type PutUserManagementUserData = {
    body: CreateUserRequest;
    path?: never;
    query?: never;
    url: '/user-management/user';
};

export type PutUserManagementUserErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Conflict
     */
    409: MessageResponse;
};

export type PutUserManagementUserError = PutUserManagementUserErrors[keyof PutUserManagementUserErrors];

export type PutUserManagementUserResponses = {
    /**
     * Created
     */
    201: UserCreatedResponse;
};

export type PutUserManagementUserResponse = PutUserManagementUserResponses[keyof PutUserManagementUserResponses];

export type GetUserManagementUserSearchData = {
    body?: never;
    path?: never;
    query?: {
        field?: SearchFieldType;
        value?: string;
        exact?: boolean;
    };
    url: '/user-management/user/search';
};

export type GetUserManagementUserSearchErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUserManagementUserSearchError = GetUserManagementUserSearchErrors[keyof GetUserManagementUserSearchErrors];

export type GetUserManagementUserSearchResponses = {
    /**
     * OK
     */
    200: ExistingUserIdResponse;
};

export type GetUserManagementUserSearchResponse = GetUserManagementUserSearchResponses[keyof GetUserManagementUserSearchResponses];

export type GetUserManagementUserByUserIdData = {
    body?: never;
    path: {
        userId: string;
    };
    query?: never;
    url: '/user-management/user/{userId}';
};

export type GetUserManagementUserByUserIdErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type GetUserManagementUserByUserIdError = GetUserManagementUserByUserIdErrors[keyof GetUserManagementUserByUserIdErrors];

export type GetUserManagementUserByUserIdResponses = {
    /**
     * OK
     */
    200: EnrichedUser;
};

export type GetUserManagementUserByUserIdResponse = GetUserManagementUserByUserIdResponses[keyof GetUserManagementUserByUserIdResponses];

export type PutUserManagementUserByUserIdData = {
    body: UpdateUserRequest;
    path: {
        userId: string;
    };
    query?: never;
    url: '/user-management/user/{userId}';
};

export type PutUserManagementUserByUserIdErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PutUserManagementUserByUserIdError = PutUserManagementUserByUserIdErrors[keyof PutUserManagementUserByUserIdErrors];

export type PutUserManagementUserByUserIdResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostUserManagementUserDeleteListData = {
    body: DeleteUsersRequestBody;
    path?: never;
    query?: never;
    url: '/user-management/user/deleteList';
};

export type PostUserManagementUserDeleteListErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
};

export type PostUserManagementUserDeleteListError = PostUserManagementUserDeleteListErrors[keyof PostUserManagementUserDeleteListErrors];

export type PostUserManagementUserDeleteListResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type PostUserManagementUserByUserIdResetPasswordData = {
    body: ResetPasswordRequest;
    path: {
        userId: string;
    };
    query?: never;
    url: '/user-management/user/{userId}/reset-password';
};

export type PostUserManagementUserByUserIdResetPasswordErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Forbidden
     */
    403: MessageResponse;
    /**
     * Not Found
     */
    404: MessageResponse;
};

export type PostUserManagementUserByUserIdResetPasswordError = PostUserManagementUserByUserIdResetPasswordErrors[keyof PostUserManagementUserByUserIdResetPasswordErrors];

export type PostUserManagementUserByUserIdResetPasswordResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetUsersNotificationsData = {
    body?: never;
    path?: never;
    query?: {
        page?: number | string;
        pageSize?: number | string;
    };
    url: '/users/notifications';
};

export type GetUsersNotificationsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUsersNotificationsError = GetUsersNotificationsErrors[keyof GetUsersNotificationsErrors];

export type GetUsersNotificationsResponses = {
    /**
     * OK
     */
    200: NotificationsResponse;
};

export type GetUsersNotificationsResponse = GetUsersNotificationsResponses[keyof GetUsersNotificationsResponses];

export type DeleteUsersNotificationsReadData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/notifications/read';
};

export type DeleteUsersNotificationsReadResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type DeleteUsersNotificationsReadResponse = DeleteUsersNotificationsReadResponses[keyof DeleteUsersNotificationsReadResponses];

export type PostUsersNotificationsReadData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/notifications/read';
};

export type PostUsersNotificationsReadErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type PostUsersNotificationsReadError = PostUsersNotificationsReadErrors[keyof PostUsersNotificationsReadErrors];

export type PostUsersNotificationsReadResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type PostUsersNotificationsReadResponse = PostUsersNotificationsReadResponses[keyof PostUsersNotificationsReadResponses];

export type PostUsersNotificationsByIdReadData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/users/notifications/{id}/read';
};

export type PostUsersNotificationsByIdReadErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type PostUsersNotificationsByIdReadError = PostUsersNotificationsByIdReadErrors[keyof PostUsersNotificationsByIdReadErrors];

export type PostUsersNotificationsByIdReadResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type PostUsersNotificationsByIdReadResponse = PostUsersNotificationsByIdReadResponses[keyof PostUsersNotificationsByIdReadResponses];

export type GetUsersNotificationSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/notification-settings';
};

export type GetUsersNotificationSettingsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUsersNotificationSettingsError = GetUsersNotificationSettingsErrors[keyof GetUsersNotificationSettingsErrors];

export type GetUsersNotificationSettingsResponses = {
    /**
     * OK
     */
    200: Array<AggregatedNotificationSettings>;
};

export type GetUsersNotificationSettingsResponse = GetUsersNotificationSettingsResponses[keyof GetUsersNotificationSettingsResponses];

export type PutUsersNotificationSettingsData = {
    body: SetNotificationSettingsRequest;
    path?: never;
    query?: never;
    url: '/users/notification-settings';
};

export type PutUsersNotificationSettingsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type PutUsersNotificationSettingsError = PutUsersNotificationSettingsErrors[keyof PutUsersNotificationSettingsErrors];

export type PutUsersNotificationSettingsResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type PutUsersNotificationSettingsResponse = PutUsersNotificationSettingsResponses[keyof PutUsersNotificationSettingsResponses];

export type PutUsersSwitchTenantData = {
    body: SwitchTenantRequest;
    path?: never;
    query?: never;
    url: '/users/switch-tenant';
};

export type PutUsersSwitchTenantErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
    /**
     * Unauthorized
     */
    401: MessageResponse;
};

export type PutUsersSwitchTenantError = PutUsersSwitchTenantErrors[keyof PutUsersSwitchTenantErrors];

export type PutUsersSwitchTenantResponses = {
    /**
     * OK
     */
    200: SwitchTenantResponse;
};

export type PutUsersSwitchTenantResponse = PutUsersSwitchTenantResponses[keyof PutUsersSwitchTenantResponses];

export type GetUsersTenantContextData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/tenant-context';
};

export type GetUsersTenantContextResponses = {
    /**
     * OK
     */
    200: TenantInfoResponse;
};

export type GetUsersTenantContextResponse = GetUsersTenantContextResponses[keyof GetUsersTenantContextResponses];

export type PutUsersSettingsData = {
    body: UpsertUserSettingsRequest;
    path?: never;
    query?: never;
    url: '/users/settings';
};

export type PutUsersSettingsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type PutUsersSettingsError = PutUsersSettingsErrors[keyof PutUsersSettingsErrors];

export type PutUsersSettingsResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type PutUsersSettingsResponse = PutUsersSettingsResponses[keyof PutUsersSettingsResponses];

export type GetUsersByBrowserLocaleSettingsData = {
    body?: never;
    path: {
        browserLocale: string;
    };
    query?: never;
    url: '/users/{browserLocale}/settings';
};

export type GetUsersByBrowserLocaleSettingsErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUsersByBrowserLocaleSettingsError = GetUsersByBrowserLocaleSettingsErrors[keyof GetUsersByBrowserLocaleSettingsErrors];

export type GetUsersByBrowserLocaleSettingsResponses = {
    /**
     * OK
     */
    200: UserSettings;
};

export type GetUsersByBrowserLocaleSettingsResponse = GetUsersByBrowserLocaleSettingsResponses[keyof GetUsersByBrowserLocaleSettingsResponses];

export type GetUsersTenantImageData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/tenant-image';
};

export type GetUsersTenantImageErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUsersTenantImageError = GetUsersTenantImageErrors[keyof GetUsersTenantImageErrors];

export type GetUsersTenantImageResponses = {
    /**
     * OK
     */
    200: TenantImageResponse;
};

export type GetUsersTenantImageResponse = GetUsersTenantImageResponses[keyof GetUsersTenantImageResponses];

export type PostUsersTenantImageData = {
    body: {
        file?: IFormFile;
    };
    path?: never;
    query?: never;
    url: '/users/tenant-image';
};

export type PostUsersTenantImageErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type PostUsersTenantImageError = PostUsersTenantImageErrors[keyof PostUsersTenantImageErrors];

export type PostUsersTenantImageResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type GetUsersTenantImagesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/tenant-images';
};

export type GetUsersTenantImagesErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type GetUsersTenantImagesError = GetUsersTenantImagesErrors[keyof GetUsersTenantImagesErrors];

export type GetUsersTenantImagesResponses = {
    /**
     * OK
     */
    200: TenantImagesResponse;
};

export type GetUsersTenantImagesResponse = GetUsersTenantImagesResponses[keyof GetUsersTenantImagesResponses];

export type DeleteUsersTenantIconData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/tenant-icon';
};

export type DeleteUsersTenantIconErrors = {
    /**
     * Bad Request
     */
    400: MessageResponse;
};

export type DeleteUsersTenantIconError = DeleteUsersTenantIconErrors[keyof DeleteUsersTenantIconErrors];

export type DeleteUsersTenantIconResponses = {
    /**
     * OK
     */
    200: MessageResponse;
};

export type DeleteUsersTenantIconResponse = DeleteUsersTenantIconResponses[keyof DeleteUsersTenantIconResponses];

export type GetValidationDeviceExistsData = {
    body?: never;
    path?: never;
    query?: {
        deviceId?: string;
    };
    url: '/validation/deviceExists';
};

export type GetValidationDeviceExistsResponses = {
    /**
     * OK
     */
    200: number | string;
};

export type GetValidationDeviceExistsResponse = GetValidationDeviceExistsResponses[keyof GetValidationDeviceExistsResponses];
